import React from 'react';
import { PopupEnum, PopupMessageContent, OwnershipTransferStep, OwnershipTransferCustomerStep } from '../Constant/Constant';
import { connect } from 'react-redux';
import { setShowPopUp, setCurrentStep } from '../OwnershipTransferCustomerSlice';
import CustomerValidationResult from '../../OwnershipTransferBlock/Popups/CustomerValidationResult';
import ServiceAccessForm from '../../../Shared/ServiceAccessForm/ServiceAccessForm';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../../Config';
import { serviceData } from '../Constant/ServiceFormText';

const OwnershipTransferCustomerPopup = (props) => {
  function lobby() {
    EpiContext.navigateTo(Config.lobbyUrl);
    props.setShowPopUp(false);
  }
  // function validateSignatureStatus() {
  //   props.setShowPopUp(false);
  //   let reqData = {
  //     RequestId: props.data.requestId,
  //     OrgId: props.data.customerOrgId,
  //     SubscriberPhoneNumber: props.data.customerPhoneNumber,
  //   };
  //   props.validateRequestStatus(reqData);
  // }

  function nextStepAfterStatusValidation() {
    if (props.data.currentEquipmentObligations?.length > 0) {
      props.setCurrentStep(OwnershipTransferCustomerStep.EquipmentObligations);
    }
    else if (props.data.cellcomDu) {
      props.setCurrentStep(OwnershipTransferCustomerStep.CellcomDu);
    } else {
      props.setCurrentStep(OwnershipTransferCustomerStep.SubscriberPersonalData);
    }
    props.setShowPopUp(false)
  }
  const popupActions = {
    closePopup: () => props.setShowPopUp(false),
    //validateSignatureStatus: () => validateSignatureStatus(),
    nextStepAfterStatusValidation: () => nextStepAfterStatusValidation(),
  };

  let currentPopUp = () => {
    switch (props.data.currentPopUp) {
      case PopupEnum.ServiceFormPopup:
        return <ServiceAccessForm setShowPopUp={props.setShowPopUp} serviceData={serviceData} />;
      case PopupEnum.CustomerValidationResult:
        return (
          <CustomerValidationResult
            popupData={props.data.currentPopupData}
            buttonClick={popupActions[props.data.currentPopupData.buttonClick]}
            secondButtonClick={popupActions[props.data.currentPopupData.secondButtonClick]}
          />
        );
      default:
        break;
    }
  };

  return <div>{currentPopUp()}</div>;
};
const mapStateToProps = (state) => ({
  data: state.OwnershipTransferCustomer,
});

const mapDispatchToProps = { setShowPopUp, setCurrentStep };

export default connect(mapStateToProps, mapDispatchToProps)(OwnershipTransferCustomerPopup);
